import {
  Box,
  Dialog,
  TextField,
  Button,
  makeStyles,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  withStyles,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import QRCode from "qrcode.react";

import usePaymentChannels from "../../../../hooks/usePaymentChannels";
import { PaymentChannel } from "../../../../models/Payment";
import { useTranslate } from "react-admin";
import DialogCloseButton from "../../../../components/DialogCloseButton";

//const PAYMENTTYPES = ["Cash", "Credit", "Transfer"];

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: 850,
    // height: 508,
    margin: "0 auto ",
    // paddingTop: 50,
    // marginTop: 30,
  },
  title: {
    fontSize: 30,
    color: theme.orange,
    marginTop: "20px",
  },
  paper: {
    margin: 0,
    width: 850,
    // height: 500,
    maxWidth: 850,
    borderRadius: "12px",
    // maxHeight: 500,
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    width: "auto",
    padding: "8px 48px",
    backgroundColor: theme.dardGray,
  },
  paymentRow: {
    // display: "flex",
    // width: 800,
    // minHeight: 50,
    // alignItems: "center",
    marginTop: 20,
    display: "grid",
    width: "100%",
    rowGap: "10px",
    gridAutoColumns: "auto 80px",
    gridTemplateAreas: "'area circle'",
  },
  paymentTypeArea: {
    gridArea: "area",
    backgroundColor: theme.lightOrange,
    borderRadius: 8,
    boxSizing: "border-box",
    padding: 24,
    width: "100%",
    gridTemplateRows: "auto",
  },
  circleButton: {
    justifySelf: "right",
    gridArea: "circle",
    borderRadius: 50,
    width: 50,
    height: 50,
    maxHeight: 50,
    minHeight: 50,
    maxWidth: 50,
    minWidth: 50,
  },
  minusButton: {
    alignSelf: "center",
    marginTop: 20,
  },
  dialogActions: {
    padding: 0,
    height: "auto",
    paddingTop: "10px",
    alignItems: "center",
    overflow: "hidden",
    display: "grid",
    gridTemplateColumns: "25% 25% 25% 25%",
    gridTemplateRows: "40px 69px",
    rowGap: 4,
    gridTemplateAreas: `"total . . remain"
                        "pay pay pay pay "`,
  },
  total: {
    gridArea: "total",
    marginLeft: 48,
  },
  remain: {
    gridArea: "remain",
    textAlign: "right",
    paddingRight: 48,
  },
  remainExceed: {
    color: theme.red,
  },
  pay: {
    width: "100%",
    height: "100%",
    gridArea: "pay",
    borderRadius: 0,
    fontSize: 24,
    padding: 20,
  },
}));

const StyledTextField = withStyles(() => ({
  root: {
    marginTop: 0,
  },
}))(TextField);

const SimpleSplitPayment = ({
  onClose,
  openDialog,
  paymentValue = 0,
  onSubmit,
}) => {
  const [payments, setPayments] = useState([{}]);
  const translate = useTranslate();

  const {
    banks,
    getCardsfromBank,
    transfers: sellerBanks,
    loading,
    getDefaultBank,
    getDefaultCard,
  } = usePaymentChannels();
  const classes = useStyles();

  const handleChangePaymentType = (newType, index) => {
    let newPayments = [...payments];
    newPayments[index] = { type: newType };
    setPayments([...newPayments]);
  };

  const handleRemovePayment = (removeIndex) => {
    let newPayments = payments.filter((_, index) => index !== removeIndex);

    setPayments([...newPayments]);
  };

  const handleAmountChange = ({ index, amount }) => {
    payments[index] = {
      ...payments[index],
      amount: amount,
    };
    setPayments([...payments]);
  };

  const handleBankChange = ({ index, newBank }) => {
    payments[index] = {
      ...payments[index],
      instituteId: newBank.id,
      instituteName: newBank.name,
      actionCode: newBank.action_code,
    };
    //   alert(JSON.stringify(payments[index]));
    setPayments([...payments]);
  };

  const handleCardChange = ({ index, newCard }) => {
    payments[index] = {
      ...payments[index],
      cardId: newCard.id,
      cardName: newCard.name,
    };
    setPayments([...payments]);
  };

  const handleCustomerBankChange = ({ index, newBank }) => {
    payments[index] = {
      ...payments[index],

      instituteId: newBank.id,
      instituteName: newBank.name,
      // senderInstituteId: newBank.id,
      // senderInstituteName: newBank.name,
    };
    setPayments([...payments]);
  };

  const handleSellerBankChange = ({ index, newSellerBank }) => {
    payments[index] = {
      ...payments[index],
      sellerInstituteId: newSellerBank.institute.id,
      sellerInstituteName: newSellerBank.name,
      newSellerBank: newSellerBank,
    };
    setPayments([...payments]);
  };

  if (loading) return null;

  const sumAmount = payments.reduce(
    (total, current) => total + Number(current.amount ?? 0),
    0
  );

  const isExceedAmount = paymentValue < sumAmount;
  const isUnderAmount = paymentValue > sumAmount;
  return (
    <>
      <Dialog
        classes={{ root: classes.allContainer, paper: classes.paper }}
        onClose={() => {
          onClose();
          setPayments([{}]);
        }}
        open={openDialog}
      >
        <DialogTitle style={{ padding: "40px 24px", paddingBottom: "2px" }}>
          <DialogCloseButton onClose={onClose} />
          <Typography align="center" classes={{ root: classes.title }}>
            {translate("ra.text.paymentMethod.split")}
          </Typography>
        </DialogTitle>
        <DialogContent scroll="body" classes={{ root: classes.dialogContent }}>
          {payments.map((payment, index) => {
            return (
              <Box className={classes.paymentRow}>
                {!payment.type ? (
                  <Box className={classes.paymentTypeArea}>
                    <PaymentTypeSelector
                      onChange={(newType) =>
                        handleChangePaymentType(newType, index)
                      }
                    />
                  </Box>
                ) : null}

                {payment.type === "Cash" ? (
                  <>
                    <PaymentCash
                      initialValue={payment.amount}
                      translate={translate}
                      onTypeChange={(newType) =>
                        handleChangePaymentType(newType, index)
                      }
                      onAmountChange={(amount) => {
                        handleAmountChange({ index: index, amount: amount });
                      }}
                    />
                  </>
                ) : null}

                {payment.type === "Credit-Debit" ? (
                  <PaymentCredit
                    paymentInitialValue={payment}
                    translate={translate}
                    onTypeChange={(newType) =>
                      handleChangePaymentType(newType, index)
                    }
                    banks={banks}
                    onBankChange={(newBank) => {
                      handleBankChange({ index: index, newBank: newBank });
                    }}
                    onCardChange={(newCard) => {
                      handleCardChange({ index: index, newCard: newCard });
                    }}
                    onAmountChange={(amount) => {
                      handleAmountChange({ index: index, amount: amount });
                    }}
                    cards={getCardsfromBank(payment.instituteName ?? null)}
                  />
                ) : null}

                {payment.type === "Transfer" ? (
                  <PaymentTransfer
                    paymentInitialValue={payment}
                    translate={translate}
                    onTypeChange={(newType) =>
                      handleChangePaymentType(newType, index)
                    }
                    sellerBanks={sellerBanks}
                    onCustomerBankChange={(newBank) => {
                      handleCustomerBankChange({
                        index: index,
                        newBank: newBank,
                      });
                    }}
                    onSellerBankChange={(newBank) => {
                      handleSellerBankChange({
                        index: index,
                        newSellerBank: newBank,
                      });
                    }}
                    onAmountChange={(amount) => {
                      handleAmountChange({ index: index, amount: amount });
                    }}
                    selectedBank={payments[index].newSellerBank}
                    customerBanks={banks}
                  />
                ) : null}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleRemovePayment(index)}
                  className={classes.circleButton}
                >
                  <RemoveIcon />
                </Button>
              </Box>
            );
          })}
          <Button
            className={[classes.circleButton, classes.minusButton]}
            variant="contained"
            color="primary"
            onClick={() => {
              let newPayments = [...payments];
              newPayments.push({});
              setPayments(newPayments);
            }}
          >
            <AddIcon />
          </Button>
          <Button onClick={() => alert(JSON.stringify(payments))}></Button>
        </DialogContent>
        <DialogActions disableSpacing classes={{ root: classes.dialogActions }}>
          <Typography variant="h5" className={classes.total}>
            {translate("ra.text.addProduct.total")}{" "}
            {paymentValue ? paymentValue : 0}
          </Typography>
          <Typography
            variant="h4"
            className={[
              classes.remain,
              isExceedAmount ? classes.remainExceed : null,
            ]}
          >
            {translate("ra.text.current")}{" "}
            {payments.reduce(
              (total, current) => total + Number(current.amount ?? 0),
              0
            )}
          </Typography>
          <Button
            disabled={isExceedAmount || isUnderAmount}
            className={classes.pay}
            variant="contained"
            color="primary"
            onClick={() =>
              onSubmit(
                payments.map((payment) => {
                  delete payment.newSellerBank;
                  if (payment.type === "Credit-Debit") {
                    if (!payment.instituteId) {
                      payment.instituteId = getDefaultBank().id;
                      payment.instituteName = getDefaultBank().name;
                    }
                    if (!payment.cardId) {
                      payment.cardId = getDefaultCard().id;
                      payment.cardName = getDefaultCard().name;
                    }
                  } else if (payment.type === "Transfer") {
                    if (!payment.instituteId) {
                      payment.instituteId = getDefaultBank().id;
                      payment.instituteName = getDefaultBank().name;
                    }
                  }

                  return new PaymentChannel({ ...payment });
                })
              )
            }
          >
            {translate("ra.text.paymentMethod.pay")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const usePaymentTypeStyles = makeStyles((theme) => ({
  container: {
    width: 200,
    display: "flex",
    flexDirection: "column",
    gridArea: "type",
  },
  autocomplete: { width: 200 },
}));

const PaymentTypeSelector = ({ onChange, type, className }) => {
  const translate = useTranslate();
  const PaymentTypeData = [
    { name: "Cash", label: translate("ra.text.paymentMethod.cash") },
    { name: "Credit-Debit", label: translate("ra.text.paymentMethod.card") },
    { name: "Transfer", label: translate("ra.text.paymentMethod.transfer") },
  ];
  const classes = usePaymentTypeStyles();
  return (
    <Box className={classes.container}>
      <Typography variant="h5" style={{ marginBottom: 5 }}>
        {translate("ra.text.paymentMethod.paymentType")}
      </Typography>
      <Autocomplete
        options={PaymentTypeData}
        className={classes.autocomplete}
        getOptionLabel={(option) => {
          return option.label;
        }}
        getOptionSelected={(option) => option.label}
        onChange={(_, newType) => {
          return onChange(newType.name);
        }}
        value={PaymentTypeData.find((p) => p.name === type)}
        renderInput={(params) => (
          <TextField
            variant="outlined"
            // underlineShow={false}
            placeholder={translate("ra.text.select")}
            {...params}
          />
        )}
      ></Autocomplete>
    </Box>
  );
};

const usePaymentCashStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.lightOrange,
    borderRadius: 8,
    boxSizing: "border-box",
    padding: 24,
    display: "grid",
    width: "100%",
    gridTemplateColumns: "200px auto 200px",
    rowGap: "5px",
    columnGap: "5px",
    gridArea: "area",
    gridTemplateRows: "auto",
    gridTemplateAreas: `"type . amount"`,
  },
  amount: {
    gridArea: "amount",
    justifySelf: "center",
    alignSelf: "center",
    marginTop: 30,
  },
}));
const PaymentCash = ({
  initialValue,
  onTypeChange,
  onAmountChange,
  translate,
}) => {
  const classes = usePaymentCashStyles();

  return (
    <Box className={classes.container}>
      <PaymentTypeSelector onChange={onTypeChange} type={"Cash"} />
      <StyledTextField
        onChange={(e) => onAmountChange(e.target.value)}
        label={translate("ra.text.amount")}
        variant="outlined"
        type="number"
        defaultValue={initialValue}
        className={classes.amount}
        inputProps={{ step: 1 }}
      ></StyledTextField>
    </Box>
  );
};

const usePaymentCreditStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.lightOrange,
    boxSizing: "border-box",
    padding: 24,
    borderRadius: 8,
    display: "grid",
    gridTemplateColumns: "200px auto 200px",
    gridArea: "area",
    rowGap: "5px",
    columnGap: "5px",
    gridTemplateRows: "auto",
    gridTemplateAreas: `
    "type      .    . "
    "banktitle .    ."
    "bank      bank . "
    "cardtitle .    . "
    "card      card amount"`,
  },
  bank: { gridArea: "bank" },
  bankTitle: { gridArea: "banktitle" },
  card: { gridArea: "card" },
  cardTitle: { gridArea: "cardtitle" },
  amount: { gridArea: "amount" },
}));
const PaymentCredit = ({
  onTypeChange,
  banks,
  onBankChange,
  onCardChange,
  onAmountChange,
  cards,
  translate,
  paymentInitialValue,
}) => {
  const classes = usePaymentCreditStyles();

  return (
    <Box className={classes.container}>
      <PaymentTypeSelector onChange={onTypeChange} type={"Credit-Debit"} />
      <Typography variant="h5" className={classes.cardTitle}>
        {translate("ra.text.paymentMethod.selectCardType")}{" "}
      </Typography>
      <Autocomplete
        className={classes.bank}
        options={banks}
        defaultValue={{ name: paymentInitialValue.instituteName }}
        getOptionLabel={(bank) => bank.name}
        label={"select bank"}
        onChange={(_, newBank) => {
          onBankChange(newBank);
        }}
        renderInput={(params) => (
          <TextField
            variant="outlined"
            // underlineShow={false}
            placeholder={translate("ra.text.paymentMethod.selectBank")}
            {...params}
          />
        )}
      ></Autocomplete>
      <Typography variant="h5" className={classes.bankTitle}>
        {translate("ra.text.paymentMethod.selectBank")}
      </Typography>
      <Autocomplete
        className={classes.card}
        options={cards}
        defaultValue={{ name: paymentInitialValue.cardName }}
        getOptionLabel={(card) => card.name}
        onChange={(_, newCard) => onCardChange(newCard)}
        renderInput={(params) => (
          <TextField
            variant="outlined"
            // underlineShow={false}
            placeholder={translate("ra.text.paymentMethod.selectCardType")}
            {...params}
          />
        )}
      ></Autocomplete>
      <StyledTextField
        type="number"
        defaultValue={paymentInitialValue.amount}
        className={classes.amount}
        onChange={(e) => onAmountChange(e.target.value)}
        label={translate("ra.text.amount")}
        variant="outlined"
      ></StyledTextField>
    </Box>
  );
};

const usePaymentTransferStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.lightOrange,
    boxSizing: "border-box",
    padding: 24,
    borderRadius: 8,
    gridArea: "area",
    display: "grid",
    width: "100%",
    rowGap: "5px",
    columnGap: "5px",
    gridTemplateColumns: "200px auto 200px",
    gridTemplateRows: "auto",
    gridTemplateAreas: ` 
    "type . ."
    "stitle sinfo ."
    "seller sellerinfo sellerinfo"
    ".  sellerinfo sellerinfo"
    "ctitle . ."
    "customer . amount"
    `,
  },
  type: {
    gridArea: "type",
  },
  sellerTitle: {
    gridArea: "stitle",
  },
  sellerInfo: {
    gridArea: "sinfo",
  },
  sellerBankSelection: {
    gridArea: "seller",
  },
  sellerBankInfo: {
    boxSizing: "border-box",
    padding: 12,
    borderRadius: 12,
    gridArea: "sellerinfo",
    backgroundColor: theme.orange,
    justifySelf: "stretch",
    alignSelf: "stretch",
  },
  customerTitle: {
    gridArea: "ctitle",
  },
  customerBankSelection: {
    gridArea: "customer",
  },
  amount: {
    gridArea: "amount",
  },
}));

const PaymentTransfer = ({
  onTypeChange,
  onCustomerBankChange,
  onSellerBankChange,
  sellerBanks,
  customerBanks,
  selectedBank,
  onAmountChange,
  translate,
  paymentInitialValue,
}) => {
  const classes = usePaymentTransferStyles();
  return (
    <Box className={classes.container}>
      <PaymentTypeSelector
        className={classes.type}
        onChange={onTypeChange}
        type={"Transfer"}
      />
      <Typography variant="h5" className={classes.sellerTitle}>
        {translate("ra.text.paymentMethod.selectSellerBank")}
      </Typography>
      <Autocomplete
        defaultValue={{ name: paymentInitialValue.instituteName }}
        className={classes.sellerBankSelection}
        options={sellerBanks}
        getOptionLabel={(option) => option.name}
        onChange={(_, selectedBank) => onSellerBankChange(selectedBank)}
        renderInput={(params) => (
          <TextField
            variant="outlined"
            // underlineShow={false}
            placeholder={translate("ra.text.paymentMethod.selectBank")}
            {...params}
          />
        )}
      ></Autocomplete>
      <Typography variant="h5" className={classes.sellerInfo}>
        {translate("ra.text.paymentMethod.bankInfo")}
      </Typography>
      <SellerBankInfo
        defaultValue={paymentInitialValue?.sellerBankInfo}
        translate={translate}
        className={classes.sellerBankInfo}
        accountName={selectedBank?.account_name}
        accountNumber={selectedBank?.account_no}
        qrData={selectedBank?.action_code}
      />
      <Typography variant="h5" className={classes.customerTitle}>
        {translate("ra.text.paymentMethod.customerBank")}
      </Typography>
      <Autocomplete
        defaultValue={{ name: paymentInitialValue.senderInstituteName }}
        className={classes.customerBankSelection}
        options={customerBanks}
        onChange={(_, newBank) => onCustomerBankChange(newBank)}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField
            variant="outlined"
            // underlineShow={false}
            placeholder={translate("ra.text.paymentMethod.selectBank")}
            {...params}
          />
        )}
      ></Autocomplete>
      <StyledTextField
        defaultValue={paymentInitialValue.amount}
        className={classes.amount}
        onChange={(e) => onAmountChange(e.target.value)}
        label={translate("ra.text.amount")}
        variant="outlined"
        type="number"
      ></StyledTextField>
    </Box>
  );
};

const useSellerBankInfoStyles = makeStyles((theme) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "25% 35% auto",
    gridTemplateRows: "50% 50%",
    gridTemplateAreas: `"accno accno qr qr"
                       "accna accna qr qr"`,
    gap: 5,
  },
  accountNumber: {
    gridArea: "accno",
    color: theme.white,
    fontWeight: "bolder",
    fontSize: 18,
  },
  accountName: {
    gridArea: "accna",
    color: theme.white,
    fontWeight: "bolder",
    fontSize: 18,
  },
  qr: {
    gridArea: "qr",
    justifySelf: "end",
  },
}));

const SellerBankInfo = ({
  accountNumber,
  accountName,
  qrData,
  className,
  translate,
  defaultValue,
}) => {
  const classes = useSellerBankInfoStyles();
  return (
    <Box className={[className, classes.container]}>
      <Typography className={classes.accountNumber}>
        {translate("ra.text.paymentMethod.accountNumber")}
        {": "}
        {accountNumber ?? defaultValue?.accountNumber}
      </Typography>
      <Typography className={classes.accountName}>
        {translate("ra.text.paymentMethod.accountName")}
        {": "}
        {accountName ?? defaultValue?.accountName}
      </Typography>
      {qrData || defaultValue?.action_code ? (
        <QRCode
          className={classes.qr}
          value={qrData ?? defaultValue?.action_code ?? ""}
          style={{
            width: 100,
            height: 100,
            backgroundColor: "transparent",
            alignContent: "end",
          }}
        ></QRCode>
      ) : (
        <Box
          className={classes.qr}
          style={{
            width: 100,
            height: 100,
            backgroundColor: "transparent",
            alignContent: "end",
          }}
        ></Box>
      )}
    </Box>
  );
};
export default SimpleSplitPayment;
